package com.writerslab

/**
 * Eagerly registers `<md-ripple>` — the only Material Web custom element we
 * need at boot, because the global MutationObserver in `index.html` injects
 * `<md-ripple>` into every clickable on first paint. The other components
 * (dialog, text field, linear / circular progress) are pulled in lazily by
 * their wrapper composables via `js("import(...)")`, which webpack splits
 * into separate chunks.
 */
@JsModule("@material/web/ripple/ripple.js")
@JsNonModule
external object MdRippleModule

private var registered = false
fun registerMdComponents() {
    if (registered) return
    @Suppress("UNUSED_VARIABLE")
    val r = MdRippleModule
    registered = true
}

// ──────────────────────────────────────────────────────────────────────
// Lazy-loaders for the bigger components. Each `js("import('literal')")`
// is a webpack code-split point — the chunk is fetched on first call.
// `loadedLazy` deduplicates so we only kick off one network request per
// module across the app's lifetime.
// ──────────────────────────────────────────────────────────────────────

private val loadedLazy = mutableSetOf<String>()

internal fun loadMdDialog() {
    if (!loadedLazy.add("dialog")) return
    js("import('@material/web/dialog/dialog.js')")
}

internal fun loadMdOutlinedTextField() {
    if (!loadedLazy.add("textfield")) return
    js("import('@material/web/textfield/outlined-text-field.js')")
}

internal fun loadMdLinearProgress() {
    if (!loadedLazy.add("linear-progress")) return
    js("import('@material/web/progress/linear-progress.js')")
}

internal fun loadMdCircularProgress() {
    if (!loadedLazy.add("circular-progress")) return
    js("import('@material/web/progress/circular-progress.js')")
}
